import { Faq, FaqItem } from "@/components/faq"
import Heading from "@/components/heading"
import { Spacer } from "@/components/spacer"
import React, { FC } from "react"
import { up } from "styled-breakpoints"
import styled from "styled-components"

interface IFaqData {
  items?: Array<FaqItem>
  title?: string
}

interface FaqSectionProps {
  anchor?: string
  className?: string
  data?: IFaqData
}

const Wrapper = styled.div`
  max-width: 720px;
  padding: 0 16px;
  margin: 0 auto;

  ${up("md")} {
    padding: 0;
  }
`

const StyledHeading = styled(Heading)`
  ${up("md")} {
    font-size: 40px;
    line-height: 48px;
    letter-spacing: -0.8px;
  }
`

export const FaqSection: FC<FaqSectionProps> = (props) => {
  const { anchor, className, data } = props

  return (
    <Wrapper
      className={className && className !== "" ? className : ""}
      id={anchor ?? "faq"}>
      <Spacer height={{ default: "80px", md: "120px" }} />
      <StyledHeading center size="h3" title={data?.title} titleTag="h2" />
      <Spacer height={{ default: "32px", md: "64px" }} />
      <Faq data={data?.items} />
    </Wrapper>
  )
}
